import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';

interface IProps {
  defaultToken?: string;
  onValidate: (token: string) => Promise<void>;
}

export default function ValidateInvitationTokenStep(props: IProps) {
  const [token, setToken] = React.useState<string>('');
  const [tokenValid, setTokenValid] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const { onValidate, defaultToken } = props;

  React.useEffect(() => {
    setToken(defaultToken || '');
  }, [defaultToken]);

  const handleTokenChange = (newtoken: string) => {
    const trimmed = newtoken.trim();
    const length = trimmed.length;
    const isValid = length === 36;
    setToken(trimmed);
    setTokenValid(isValid);
  };

  const handleNext = async () => {
    setLoading(true);
    await onValidate(token);
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Typography sx={{ mt: 2, mb: 1 }}>Invitation Token</Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', pt: 2, gap: 2 }}>
        <TextField
          error={!tokenValid}
          type="text"
          name="token"
          label="Invitation token"
          disabled={loading}
          required={true}
          value={token}
          onChange={(e) => handleTokenChange(e.target.value)}
          helperText="A reference code from your bank"
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button
          variant="contained"
          onClick={handleNext}
          disabled={loading || !tokenValid || !token}
        >
          Next
        </Button>
      </Box>
    </React.Fragment>
  );
}
